import type { AccommodationDto } from '@hcr/api/consumer'
import { isNotNull } from '@hcr/utils'

import type { TicketsCount } from '../../hooks'

export const createAccommodationTicketsTotalCount = (
  ticketsCount: TicketsCount | null,
  accommodation: AccommodationDto
): number =>
  isNotNull(ticketsCount) &&
  ticketsCount[accommodation.resort_id] &&
  ticketsCount[accommodation.resort_id][accommodation.accommodation_id]
    ? ticketsCount[accommodation.resort_id][accommodation.accommodation_id] +
      ticketsCount[accommodation.resort_id].singleTickets
    : 0
